module.exports = __webpack_public_path__ + "static/media/person.yes.47a5dbce.png";